
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/evaluation/[shopSysNo]",
      function () {
        return require("private-next-pages/shop/evaluation/[shopSysNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/evaluation/[shopSysNo]"])
      });
    }
  